import type { CalendarMoonSignUpcomingEvent, CalendarUpcomingEvent } from '@/api/schema/calendar'
import { dayjs } from '@/api/utils/dayjs'
import { Col, Row } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { MoonIcon } from '@/app/components/MoonIcon/MoonIcon'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { getMoonEventLink } from '@/app/utils/moon'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const EventsCard: FunctionalComponent<{
  events: Array<CalendarUpcomingEvent | CalendarMoonSignUpcomingEvent>
  from?: string
}> = props => {
  return (
    <UI.Panel>
      <Row gap={10}>
        <h2 hidden>Важные события</h2>

        <Row gap={10} as='ul' class={styles.list}>
          {props.events.map(event => (
            <Col
              as='li'
              key={`${event.type}-${event.at}`}
              justifyContent='space-between'
              alignItems='center'
              class={styles.col}
              gap={10}
            >
              <Row gap={3} alignItems='center'>
                <Col gap={5} alignItems='center'>
                  <MoonIcon phase={event.moonPhase} />
                  <Text fontSize={14}>
                    <Link
                      to={getEventLink(event)}
                      class='color-link'
                    >
                      {event.title}
                    </Link>
                  </Text>
                </Col>
              </Row>
              <Text fontSize={14} opacity={0.5}>
                <EventLink event={event} from={props.from} />
              </Text>
            </Col>
          ))}
        </Row>
      </Row>
    </UI.Panel>
  )
}

function EventLink({
  event,
  from,
}: {
  event: CalendarUpcomingEvent | CalendarMoonSignUpcomingEvent
  from?: string
}) {
  const label = from
    ? dayjs(event.at).from(from)
    : dayjs(event.at).format('D MMMM HH:mm')

  return label
}

function getEventLink(event: CalendarUpcomingEvent | CalendarMoonSignUpcomingEvent) {
  switch (event.type) {
    case 'moon_sign':
      return getMoonEventLink(`/moon/sign/${event.sign.toLowerCase()}`, event.at)
    case 'full_moon':
      return getMoonEventLink(`/moon/full-moon/${event.sign.toLowerCase()}`, event.at)
    case 'new_moon':
      return getMoonEventLink(`/moon/new-moon/${event.sign.toLowerCase()}`, event.at)
    case 'lunar_day':
      return event.lunarDay
        ? getMoonEventLink(`/moon/day/${event.lunarDay}`, event.at)
        : undefined
    default:
      return undefined
  }
}
